// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, ".Preview__Preview___3NGGX{display:flex;flex-direction:row;height:100%;min-width:0}.Preview__pageView___1Yl0g:focus{outline:2px solid var(--spectrum-global-color-blue-400)}.Preview__documentViewWrapper___2uXl-{height:100%;width:100%}", ""]);
// Exports
exports.locals = {
	"Preview": "Preview__Preview___3NGGX",
	"pageView": "Preview__pageView___1Yl0g",
	"documentViewWrapper": "Preview__documentViewWrapper___2uXl-"
};
module.exports = exports;
